export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900">
              Ready to Explore More?
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
              Visit our official partner website for additional tools, templates, and product updates. Browse thousands of items across all 15+ categories.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-6 bg-primary-500 text-white px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Explore More
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </a>
          </div>

          {/* Product image banner */}
          <div className="mt-12 md:mt-16 grid grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
            <div className="relative aspect-square rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Bright%20coral%20running%20shoes%20on%20white%20marble%20surface%2C%20overhead%20studio%20lighting%2C%20clean%20product%20photography%2C%20athletic%20energy%2C%20isolated%20on%20white%20background&width=400&height=400&seq=cta-v2-prod-01&orientation=squarish"
                alt="Shoes at Kaspreadsheet"
                title="Shop Shoes at Kaspreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="relative aspect-square rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Terracotta%20orange%20hoodie%20folded%20on%20light%20grey%20concrete%2C%20soft%20overhead%20lighting%2C%20minimal%20product%20photography%2C%20cozy%20casual%20style%2C%20isolated%20composition&width=400&height=400&seq=cta-v2-prod-02&orientation=squarish"
                alt="Hoodies at Kaspreadsheet"
                title="Shop Hoodies at Kaspreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="relative aspect-square rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Mint%20green%20cotton%20t-shirt%20on%20warm%20wooden%20surface%2C%20natural%20daylight%2C%20clean%20product%20photography%2C%20fresh%20spring%20aesthetic%2C%20isolated%20style&width=400&height=400&seq=cta-v2-prod-03&orientation=squarish"
                alt="T-Shirts at Kaspreadsheet"
                title="Shop T-Shirts at Kaspreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="relative aspect-square rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Chocolate%20brown%20leather%20jacket%20on%20smooth%20stone%20surface%2C%20dramatic%20side%20lighting%2C%20luxury%20product%20photography%2C%20rich%20texture%20detail%2C%20isolated%20composition&width=400&height=400&seq=cta-v2-prod-04&orientation=squarish"
                alt="Jackets at Kaspreadsheet"
                title="Shop Jackets at Kaspreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="relative aspect-square rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Mustard%20yellow%20canvas%20tote%20bag%20on%20white%20surface%2C%20bright%20studio%20lighting%2C%20minimal%20product%20photography%2C%20summer%20accessory%20style%2C%20isolated%20composition&width=400&height=400&seq=cta-v2-prod-05&orientation=squarish"
                alt="Bags at Kaspreadsheet"
                title="Shop Bags at Kaspreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="relative aspect-square rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Deep%20plum%20glass%20perfume%20bottle%20on%20black%20matte%20surface%2C%20soft%20spotlight%2C%20elegant%20product%20photography%2C%20luxurious%20fragrance%20aesthetic%2C%20isolated%20composition&width=400&height=400&seq=cta-v2-prod-06&orientation=squarish"
                alt="Perfumes at Kaspreadsheet"
                title="Shop Perfumes at Kaspreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}